import React, { useEffect } from 'react';
import { Analytics } from '@trello/atlassian-analytics';
import { FreeTrialUpsellModal } from './FreeTrialUpsellModal';

export interface UpsellOverlayProps {
  onLearnMore(): void;
  onCtaClick: () => void;
  orgId: string;
  isLoading?: boolean;
}

export const UpsellOverlay: React.FC<UpsellOverlayProps> = ({
  onLearnMore,
  orgId,
  onCtaClick,
  isLoading,
}) => {
  useEffect(() => {
    Analytics.sendScreenEvent({
      name: 'freeTrialModal',
      containers: {
        organization: {
          id: orgId,
        },
      },
    });
  }, [orgId]);

  return (
    <FreeTrialUpsellModal
      isLoading={isLoading}
      onPrimaryClick={onCtaClick}
      onSecondaryClick={onLearnMore}
      orgId={orgId}
    />
  );
};
